import { render, staticRenderFns } from "./LiveComponent.vue?vue&type=template&id=2449d350&scoped=true"
import script from "./LiveComponent.vue?vue&type=script&lang=js"
export * from "./LiveComponent.vue?vue&type=script&lang=js"
import style0 from "./LiveComponent.vue?vue&type=style&index=0&id=2449d350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2449d350",
  null
  
)

export default component.exports